export var cookie;
(function (cookie) {
    /**
     * Get a cookie by name.
     * @param name Name of the cookie.
     * @returns The cookie value or null if not found.
     */
    cookie.get = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    };
    /**
     * Set a cookie.
     * @param name Name of the cookie.
     * @param value Value of the cookie.
     * @param days Number of days until the cookie should expire. Default is session (until browser closes).
     * @param path Path where the cookie is valid. Default is '/'.
     */
    cookie.set = (name, value, days, path = '/') => {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = `; expires=${date.toUTCString()}`;
        }
        document.cookie = `${name}=${value}${expires}; path=${path}`;
    };
    /**
     * Delete a cookie by name.
     * @param name Name of the cookie.
     * @param path Path where the cookie was set.
     * @param domain Domain where the cookie is used.
     */
    cookie.del = (name, path, domain) => {
        // eslint-disable-next-line max-len
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${path ? `path=${path};` : ''} ${domain ? `domain=${domain};` : ''}`;
    };
})(cookie || (cookie = {}));
